import { cn } from "tailwind-variants";
import type { SearchUmbPageContentResponseModel } from "#/_generated/umbraco/delivery-api/models";
import { Breadcrumbs } from "#/_packages/umbrella/features/breadcrumbs/components/breadcrumbs.tsx";
import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings.ts";
import { BlockGrid } from "#/_packages/umbrella/integrations/umbraco/property-components/block-grid.tsx";
import type { PageContent } from "#/_packages/umbrella/types";

import { SearchPageTagFilterContext } from "./search-page-settings";

export function Search({
    content,
}: PageContent<SearchUmbPageContentResponseModel>) {
    const siteSettings = useGetSiteSettings();
    const properties = content.properties;
    const pageTitle = properties?.heading || content.name || "";
    const mainContentContainer = toMainContentContainerClass(
        siteSettings?.mainContentContainer,
    );
    const mainContentContainerAlignment = toMainContentContainerAlignmentClass(
        siteSettings?.mainContentContainerAlignment,
    );
    return (
        <>
            {!properties?.hideBreadcrumb ? (
                <Breadcrumbs
                    currentPage={pageTitle}
                    mainContentContainer={toMainContentContainer(
                        siteSettings?.mainContentContainer,
                    )}
                    mainContentContainerAlignment={toMainContentContainerAlignment(
                        siteSettings?.mainContentContainerAlignment,
                    )}
                />
            ) : null}
            {!properties?.hidePageTitle && pageTitle ? (
                <div className="page-title-wrapper">
                    <div
                        className={cn(mainContentContainer, mainContentContainerAlignment)}
                    >
                        <h1 className="page-title">{pageTitle}</h1>
                    </div>
                </div>
            ) : null}
            <SearchPageTagFilterContext value={properties?.showContentTagFilter === true}>
                <div className={cn(mainContentContainer, mainContentContainerAlignment, "mb-8")}>
                    <BlockGrid
                        contentArea={properties?.blockGrid}
                        noVerticalSpacing={properties?.noVerticalSpacing ?? false}
                    />
                </div>
            </SearchPageTagFilterContext>
        </>
    );
}

function toMainContentContainer(value?: string | null) {
    switch (value) {
        case "fluidToSM":
        case "fluidToMD":
        case "fluidToLG":
        case "fluidToXL":
        case "fluidToXXL":
        case "alwaysFluid":
            return value;
        default:
            return "alwaysContained";
    }
}

function toMainContentContainerAlignment(value?: string | null) {
    switch (value) {
        case "start":
        case "end":
            return value;
        default:
            return "center";
    }
}

function toMainContentContainerClass(value?: string | null) {
    switch (value) {
        case "fluidToSM":
            return "container-sm";
        case "fluidToMD":
            return "container-md";
        case "fluidToLG":
            return "container-lg";
        case "fluidToXL":
            return "container-xl";
        case "fluidToXXL":
            return "container-xxl";
        case "alwaysFluid":
            return "container-fluid";
        default:
            return "container ";
    }
}

function toMainContentContainerAlignmentClass(value?: string | null) {
    switch (value) {
        case "start":
            return "container-start";
        case "end":
            return "container-end";
        default:
            return "";
    }
}
